import { render } from "./OutOfStockVariants.vue?vue&type=template&id=84e830b0&scoped=true"
import script from "./OutOfStockVariants.vue?vue&type=script&lang=js"
export * from "./OutOfStockVariants.vue?vue&type=script&lang=js"

import "./OutOfStockVariants.vue?vue&type=style&index=0&id=84e830b0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e830b0"]])

export default __exports__